import React from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import styled, { createGlobalStyle } from 'styled-components';
import { MOBILE_MEDIA_QUERY } from '../components/library/breakpoints';

const MySwal = withReactContent(Swal);

/**
 *  Fixed `header` rule in custom.css — no shared constant exists for it.
 */
const HEADER_HEIGHT = '48px';

const RESPONSIVE_POPUP_CLASS = 'responsive-swal-popup';

const ResponsivePopupStyle = createGlobalStyle({
    [`.${RESPONSIVE_POPUP_CLASS} .swal2-html-container, .${RESPONSIVE_POPUP_CLASS} .swal2-content`]: {
        padding: 0,
    },

    [`.${RESPONSIVE_POPUP_CLASS} .swal2-close`]: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        top: '10px',
        right: '10px',
        width: '19px',
        height: '19px',
        flexShrink: 0,
        color: 'var(--foreground)',
        fontFamily: 'inherit',
        fontSize: '16px',
    },

    [MOBILE_MEDIA_QUERY]: {
        [`.${RESPONSIVE_POPUP_CLASS}`]: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            width: '100% !important',
            maxWidth: '100% !important',
            height: `calc(100vh - ${HEADER_HEIGHT})`,
            maxHeight: `calc(100vh - ${HEADER_HEIGHT})`,
            margin: '0 !important',
            marginTop: `${HEADER_HEIGHT} !important`,
            borderRadius: 0,
            border: 'none',
            overflowY: 'auto',
        },
    },
});

const MobileTopPaddingWrapper = styled.div({
    [MOBILE_MEDIA_QUERY]: {
        position: 'absolute',
        top: 0,
    },
});

const RESPONSIVE_POPUP_DEFAULTS = {
    padding: 0,
    background: '#fff',
    showCloseButton: true,
    closeButtonHtml: '<i class="fal fa-times"></i>',
};

/**
 * Renders any React element inside a responsive (desktop/mobile) SweetAlert2
 * popover. Pass swalOptions to override width/padding/background/dismiss
 * behaviour etc per use case.
 */
export function showComponentModal(content, swalOptions = {}) {
    return MySwal.fire({
        html: (
            <>
                <ResponsivePopupStyle />
                <MobileTopPaddingWrapper>{content}</MobileTopPaddingWrapper>
            </>
        ),
        showConfirmButton: false,
        ...RESPONSIVE_POPUP_DEFAULTS,
        ...swalOptions,
        customClass: {
            ...swalOptions.customClass,
            popup: `${RESPONSIVE_POPUP_CLASS} ${swalOptions.customClass?.popup || ''}`.trim(),
        },
    });
}

/**
 * Closes whichever SweetAlert2 popover is currently open via showComponentModal.
 */
export function closeComponentModal() {
    MySwal.close();
}
